module.exports = __webpack_public_path__ + "static/media/Level5.4d0a7580.png";